import { render } from "./CheckBoxSquare.vue?vue&type=template&id=20622cb8&scoped=true&ts=true"
import script from "./CheckBoxSquare.vue?vue&type=script&lang=ts"
export * from "./CheckBoxSquare.vue?vue&type=script&lang=ts"

import "./CheckBoxSquare.vue?vue&type=style&index=0&id=20622cb8&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20622cb8"]])

export default __exports__